import React, { useState, useEffect, ReactNode } from "react";
import styles from "./index.module.scss";
import { SearchInput } from "../../../../shared/ui/SearchInput";
import { BANK__NAMES, BANK__ICONS } from "../../../../shared/consts";
import { Button } from "../../../../shared/ui/Button";
import "overlayscrollbars/overlayscrollbars.css";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { LeftArrowIcon } from "../../../../shared/assets/icons/leftArrow";
import sbp from "../../../../shared/assets/paymentMethods/sbp.svg";
import card from "../../../../shared/assets/paymentMethods/card.svg";
import check from "../../../../shared/assets/paymentMethods/check.svg";
import { useAppSelector } from "../../../../shared/store";
import {
  getOfferProviders,
  updatePaymentMethod,
} from "../../../../shared/store/payment/api";
import { startTimer } from "../../../../shared/utils/timer";
import { Loader } from "../../../../shared/ui/Loader";

interface IBankProvider {
  providerCode: string;
  translateName: string;
  paymentMethods: ["Sbp", "BankAccount", "Card"];
  priority: number;
  providerName: string;
}

interface IBankPaymentMethod {
  name: string;
  icon: string | ReactNode;
  value: string;
  id: number;
  providerCode: string;
  providerName: string;
}

const paymentsMethods = {
  Card: {
    name: "Перевод по карте",
    icon: card,
    value: "Card",
    id: 0,
  },
  Sbp: {
    name: "По СБП",
    icon: sbp,
    value: "Sbp",
    id: 1,
  },
  BankAccount: {
    name: "Перевод по счету",
    icon: check,
    value: "BankAccount",
    id: 2,
  },
};

const getBankName = (providerCode: string, providerName: string) => {
  return BANK__NAMES[providerCode] ? BANK__NAMES[providerCode] : providerName;
};
const getProviderIcon = (providerCode: string) => {
  return BANK__ICONS[providerCode]
    ? BANK__ICONS[providerCode]
    : BANK__ICONS["other"];
};

export const DepositeForm = () => {
  const [loading, setLoading] = useState(true);
  const offerData = useAppSelector((state) => state.payment.offer);
  const [banksFilter, setFilter] = useState("");
  const changeFilter = (value: string) => {
    setFilter(value);
  };
  const [banks, setBanks] = useState<IBankProvider[]>([]);
  const [bankPaymentMethods, setbankPaymentMethods] = useState<
    IBankPaymentMethod[]
  >([
    {
      name: "Перевод по карте",
      icon: card,
      value: "Card",
      id: 0,
      providerCode: "",
      providerName: "",
    },
    {
      name: "По СБП",
      icon: sbp,
      value: "Sbp",
      id: 1,
      providerCode: "",
      providerName: "",
    },
    {
      name: "Перевод по счету",
      icon: check,
      value: "BankAccount",
      id: 2,
      providerCode: "",
      providerName: "",
    },
  ]);
  const [choosenBank, setChoosenBank] = useState<null | IBankProvider>(null);

  const getBanks = () => {
    let result = banks;
    if (banksFilter) {
      result = banks.filter((el) =>
        el.translateName
          .toLocaleLowerCase()
          .includes(banksFilter.toLocaleLowerCase())
      );
    }

    return result;
  };

  const chooseBank = (bank: IBankProvider) => {
    setChoosenBank(bank);
    setbankPaymentMethods(
      bank.paymentMethods.map((el) => ({
        ...paymentsMethods[el],
        providerCode: bank.providerCode,
        providerName: bank.providerName,
      }))
    );
  };

  const banksList = (
    <ul className={styles.banks_list}>
      {getBanks().map((bank, index) => (
        <li
          key={index}
          className={styles.banks_list_item}
          onClick={() => {
            chooseBank(bank);
          }}
        >
          <PaymentItem
            img={getProviderIcon(bank.providerCode)}
            name={getBankName(bank.providerCode, bank.providerName)}
          />
        </li>
      ))}
    </ul>
  );

  const paymentsMethodsList = (
    <ul
      className={`${styles.banks_list} ${
        !choosenBank && styles.banks_list_hidden
      }`}
    >
      {bankPaymentMethods.map((method, index) => (
        <li
          key={index}
          className={styles.banks_list_item}
          onClick={() => {
            offerData &&
              updatePaymentMethod(offerData.id, method.id, method.providerCode);
          }}
        >
          <PaymentItem key={index} img={method.icon} name={method.name} />
        </li>
      ))}
    </ul>
  );

  useEffect(() => {
    const request = async () => {
      if (offerData) {
        const response = await getOfferProviders(offerData.id);
        if (response) {
          const banks = response.activeProviders
            .map((el) => ({
              priority: el.providerCode === "other" ? 0 : 1,
              providerCode: el.providerCode,
              translateName: getBankName(el.providerCode, el.providerName),
              paymentMethods: el.paymentMethods,
              providerName: el.providerName,
            }))
            .sort((a, b) => b.priority - a.priority);

          setBanks(banks);
        }
        setLoading(false);
      }
    };
    request();
  }, [offerData]);
  return (
    <>
      {offerData && (
        <>
          <div className={styles.form}>
            <div className={styles.form_container}>
              <h2 className={styles.title}>Пополнение</h2>
              <h3 className={styles.order_title}>ID заказа: {offerData.id}</h3>

              <div className={styles.payment_wrapper}>
                <div className={styles.payment_sum_wrapper}>
                  <div className={styles.payment_sum}>
                    {`${offerData.amountFiat} ${offerData.fiatCode}`}
                  </div>
                  <div className={styles.payment_commission}>Без комиссии</div>
                </div>
              </div>
              <h3 className={styles.bank_title}>
                {choosenBank ? "Выберите способ оплаты" : "Выберите банк"}
              </h3>
              <div className={styles.bank_description}>
                Для совершения платежа необходимо выбрать один из доступных
                банков:
              </div>
            </div>
            {!choosenBank && (
              <SearchInput
                className={styles.input}
                value={banksFilter}
                onChangeCallback={changeFilter}
              />
            )}
            <OverlayScrollbarsComponent>
              {loading ? (
                <div className={styles.loader_container}>
                  <Loader className={styles.list_loader} />
                </div>
              ) : (
                <ul>{!choosenBank && banksList}</ul>
              )}
              {paymentsMethodsList}
            </OverlayScrollbarsComponent>
            {banks.length === 0 && !loading && (
              <div className={styles.providers_alert}>
                Реквизиты больше недоступны. Пожалуйста, пересоздайте вашу
                заявку.
              </div>
            )}
          </div>
          {choosenBank ? (
            <Button
              content="Вернуться назад"
              variant="gray"
              className={styles.cancel_btn}
              icon={<LeftArrowIcon />}
              onClick={() => {
                setChoosenBank(null);
              }}
            ></Button>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

const PaymentItem = ({
  img,
  name,
}: {
  img: string | ReactNode;
  name: string;
}) => {
  const [loading, setLoading] = useState(true);
  return (
    <div className={styles.bank_btn}>
      {typeof img === "string" ? (
        <img
          src={img}
          alt="изображение банка"
          className={`${styles.bank_img} ${
            !loading ? styles.bank_img__visible : ""
          }`}
          onLoad={() => setLoading(false)}
          key={img}
        />
      ) : (
        img
      )}
      {loading && <Loader className={styles.loader} />}
      <div className={styles.bank_name}>{name}</div>
    </div>
  );
};
